module.exports = __webpack_public_path__ + "media/4.79073962.wav";